export default __webpack_public_path__ + "static/media/saint_aubin10.f9002540.jpg";